import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { IconTextModule } from '@app/components/iconText/iconText.module';
import { BlockLifeChangesComponent } from '@app/components/blocks/block-lifeChanges/block-lifeChanges.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LifeChangeModule } from '@app/components/lifeChange/lifeChange.module';
import { ButtonModule } from '@app/components/button/button.module';

@NgModule({
  imports: [CommonModule, SharedModule, IconTextModule, ReactiveFormsModule, LifeChangeModule, ButtonModule],
  declarations: [BlockLifeChangesComponent],
  exports: [BlockLifeChangesComponent],
})
export class BlockLifeChangesModule {}
